import { format } from "date-fns";
import es from "date-fns/locale/es";
import enGB from "date-fns/locale/en-GB";
import ro from "date-fns/locale/ro";

// Por codigo de idioma de i18next.
export const dateFnsLocales = {
  en: enGB,
  es,
  ro,
};

// "P" es el formato corto propio de cada idioma, en vez de uno fijo.
export const formatDate = (date, language) =>
  format(date, "P", { locale: dateFnsLocales[language] || dateFnsLocales.en });
